// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const flowApi = {
  fetchKeyFigure: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/flow/shopping-centers/${pcId}/key-figures`, 'GET').execute(),
};

export default flowApi;
